export default __webpack_public_path__ + "static/wool-9699a44d3959638126028735f717295d.png";